import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {path: '/',redirect:'/home'},
  {path: '/home',component: () => import('@/views/home.vue')},
  {path: '/login',component: () => import('@/views/login/index.vue')}, //用户登录/注册
  {path: '/itemMMC',component: () => import('@/views/item/mmc.vue')},//智慧项目-MMC
  {path: '/itemMMCT',component: () => import('@/views/item/mmct.vue')},//智慧项目-MMC糖网中心
  {path: '/itemIHEC',component: () => import('@/views/item/ihec.vue')},//智慧项目-iHEC
  {path: '/itemThreeHeight',component: () => import('@/views/item/three_height.vue')},//三高共管项目
  {path: '/life',component: () => import('@/views/life/index.vue')},//智慧生活-糖尿病百科/高血压百科
  {path: '/article',component: () => import('@/views/life/article_comp.vue'),children:[
    {path: '/tq1',component: () => import('@/views/life/lifeT/t_q1.vue')},//智慧生活-糖尿病百科-什么是糖尿病
    {path: '/tq2',component:() => import('@/views/life/lifeT/t_q2.vue')},//智慧生活-糖尿病百科-这才是糖尿病真正的危害
    {path: '/tq3',component:() => import('@/views/life/lifeT/t_q3.vue')},//智慧生活-糖尿病百科-饭、菜、肉，先吃后吃有讲究！饮食细节决定血糖控制
    {path: '/tq4',component:() => import('@/views/life/lifeT/t_q4.vue')},//智慧生活-糖尿病百科-五只手指测血糖全都不一样？别担心，听听医生怎么说。
    {path: '/tq5',component:() => import('@/views/life/lifeT/t_q5.vue')},//智慧生活-糖尿病百科-三类降糖药物的合理运用
    {path: '/gq1',component:() => import('@/views/life/lifeG/g_q1.vue')},//智慧生活-高血压百科-高血压认识十五个误区
    {path: '/gq2',component:() => import('@/views/life/lifeG/g_q2.vue')},//智慧生活-高血压百科-绝大多数患者不了解家庭自测血压的正常值
    {path: '/gq3',component:() => import('@/views/life/lifeG/g_q3.vue')},//智慧生活-高血压百科-生活中易诱发心脏病的十个小事
    {path: '/gq4',component:() => import('@/views/life/lifeG/g_q4.vue')},//智慧生活-高血压百科-“生命简单七法”让血压更平稳
    {path: '/gq5',component:() => import('@/views/life/lifeG/g_q5.vue')},//智慧生活-高血压百科-高血压治疗十大误区
  ]},
  {path: '/about',component: () => import('@/views/about.vue')},//关于我们
  {path: '/shop',component: () => import('@/views/shop/index.vue'),children:[
    {path: '/shop',component: () => import('@/views/shop/pro_list.vue')},//网上商城
    {path: '/guideBuy',component: () => import('@/views/shop/guide_buy.vue')},//网上商城-新手指南-购物流程
    {path: '/guideReg',component: () => import('@/views/shop/guide_register.vue')},//网上商城-新手指南-用户注册协议
    {path: '/guidePrivacy',component: () => import('@/views/shop/guide_privacy.vue')},//网上商城-新手指南-用户隐私协议
    {path: '/payReceive',component: () => import('@/views/shop/pay_receive.vue')},//网上商城-配送与支付-收货指南
    {path: '/payDistribution',component: () => import('@/views/shop/pay_distribution.vue')},//网上商城-配送与支付-物流配送
    {path: '/payPick',component: () => import('@/views/shop/pay_pick.vue')},//网上商城-配送与支付-上门自提
    {path: '/aftersaleRefund',component: () => import('@/views/shop/aftersale_refund.vue')},//网上商城-售后服务-如何申请退款
    {path: '/aftersalePatch',component: () => import('@/views/shop/aftersale_patch.vue')},//网上商城-售后服务-维修补件说明
    {path: '/aftersaleCancel',component: () => import('@/views/shop/aftersale_cancel.vue')},//网上商城-售后服务-取消订单
  ]},
  {path: '/proDetail',component: () => import('@/views/shop/pro_detail.vue')},//网上商城-商品详情
  {path: '/shopCart',component: () => import('@/views/shop/shop_cart.vue')},//网上商城-购物车
]

const router = new VueRouter({
  routes
})

export default router
